import React from "react";
import {
	  BarChart,
	  Bar,
	  XAxis,
	  YAxis,
	  CartesianGrid,
	  Tooltip,
	  Legend,
	  ResponsiveContainer
} from "recharts";
import {
	Button,
} from "@mui/material";

const EasyMediumHard = ({ user, gotoanalytics }) => {
	  const data = [
		      { name: "Easy", Attempted: user.easy_tests_attempted, Passed: user.easy_tests_passed },
		      { name: "Medium", Attempted: user.medium_tests_attempted, Passed: user.medium_tests_passed },
		      { name: "Hard", Attempted: user.hard_tests_attempted, Passed: user.hard_tests_passed }
		    ];

	  return (
		      <div className="container mt-4">
		        <h2>EasyMediumHard</h2>
		      <Button color="inherit" onClick={gotoanalytics} sx={{ mr: 1 }}>
			Analytics
		      </Button>
		      <br/>
		        <ResponsiveContainer width="100%" height={300}>
		          <BarChart data={data}>
		            <CartesianGrid strokeDasharray="3 3" />
		            <XAxis dataKey="name" />
		            <YAxis allowDecimals={false} />
		            <Tooltip />
		            <Legend />
		            <Bar dataKey="Attempted" fill="#8884d8" />
		            <Bar dataKey="Passed" fill="#82ca9d" />
		          </BarChart>
		        </ResponsiveContainer>
		      </div>
		    );
};

export default EasyMediumHard;

